import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { REACT_APP_API_URL } from "../env";
import { toast } from "react-toastify";

const FailurePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handlePopState = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  // 🔹 Log payment failure once when page opens
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const bookingRef = params.get("bookingRef");
    const errorDetails = {
      code:
        params.get("error[code]") || params.get("code") || "UNKNOWN_FAILURE",
      description:
        params.get("error[description]") ||
        params.get("description") ||
        "Payment was not completed.",
      reason:
        params.get("error[reason]") ||
        params.get("reason") ||
        params.get("payment_failure_reason") ||
        "cancelled_by_user_or_timeout",
      step: params.get("error[step]") || params.get("step") || "payment_page",
      source: params.get("error[source]") || params.get("source") || "customer",
      metadata: {
        payment_id:
          params.get("error[metadata][payment_id]") ||
          params.get("payment_id") ||
          null,
        order_id:
          params.get("error[metadata][order_id]") ||
          params.get("order_id") ||
          null,
      },
    };

    if (bookingRef) {
      const payload = { bookingRef, error: errorDetails };

      console.log("Logging payment failure with payload:", payload);

      axios
      
        // Sending the cancellation here releases the Redis inventory hold right away.
        .post(`${REACT_APP_API_URL}/api/log-failed-payment`, payload)
        .then((response) => {
          console.log("Payment failure logged successfully:", response.data);
          if (response.data.status === "logged") {
            toast.info("Payment failure has been recorded.");
          }
        })
        .catch(() => {
          toast.error("Payment failed.");
        });
    } else {
      console.warn("No bookingRef found in URL for failure logging.");
    }
  }, [location]);

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 3000); 

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div
      className="container"
      style={{ maxWidth: "600px", margin: "25px auto", padding: "20px" }}
    >
      <div
        className="alert alert-danger text-center"
        role="alert"
        style={{
          marginTop: "10%",
          marginBottom: "5%",
          background: "transparent",
          border: "2px solid white",
        }}
      >
        <h4 className="alert-heading">Booking Failed!</h4>
        <p>Unfortunately, your hotel booking could not be completed.</p>
        <span className="text-danger">
          Please try again or contact us at&nbsp;
          <a href="mailto:jtdcltd@gmail.com" className="text-danger">
            jtdcltd@gmail.com
          </a>
          &nbsp;if the issue persists.
        </span>
        <hr />
        <Link to="/" className="btn btn-secondary mt-3">
          Go to Homepage
        </Link>
      </div>
    </div>
  );
};

export default FailurePage;
